import {
  useCallback, useEffect, useMemo, useState 
} from "react";

export const useFilterBlock = (props) => {
  const {
    filterState,
    items,
    initialOpen,
    activeFilter,
    isMobile,
    filterCondition
  } = props;

  const hasSelected = useMemo(() => {
    return items.some((item) => {
      return filterState && filterState.has(item);
    });
  }, [filterState, items]);

  const [isExpanded, setExpanded] = useState(hasSelected || initialOpen);

  useEffect(() => {
    setExpanded(hasSelected || initialOpen);
  }, [hasSelected, initialOpen]);

  const handleClick = useCallback(
    (name) => {
      if (isMobile) {
        if (!hasSelected) {
          setExpanded(true);
        }

        activeFilter(name);
      } else {
        setExpanded((value) => !value);
      }
    },
    [setExpanded]
  );

  return {
    handleClick,
    isExpanded
  };
};
